<div class="my-classes-empty">
  <div class="empty-image">
    <img [src]="getImageUrl()" [alt]="empty?.title | translate" class="image">
  </div>
  <div class="text-wrap">
    <h5 *ngIf="empty?.title" class="title">{{ empty?.title | translate }}</h5>
    <p class="text">{{ empty?.text | translate }}</p>
    <a *ngIf="empty?.link_label" [routerLink]="empty?.link_auth && isGuest ? null : empty?.link" class="link" (click)="goSignup($event)">
      {{ empty?.link_label | translate }}
    </a>
  </div>
  <a [routerLink]="isGuest ? null : empty?.link2" class="icon" (click)="goSignup($event)">
    <app-icon width="36" height="28" file="arrow" icon="right2"></app-icon>
  </a>
</div>
